export type UploadFile = {
  id: string
  name: string
  size?: number
  percent?: number
  type?: string
  videoId?: string
}

export type PluploadResponse = {
  response: string
  responseHeaders: string
  status: number
}

export type MultimediaUploadResponse = {
  id: string
  bucketName: string
  url: string
  title: string
  contentType: string
  creationDate: string
  size: number
  source: string
  floorplan: boolean
  picture: boolean
  document: boolean
  valid: boolean
}

export type MultimediaLinkUploadResponse = {
  id: string
  linkUrl: string
  title: string
  creationDate: string
  source: string
  document: boolean
  floorplan: boolean
  file: boolean
  valid: boolean
  link: boolean
  picture: boolean
}

export enum MultimediaUploaderType {
  PICTURE = 'jpg,png,jpeg,gif',
  DOCUMENT = 'pdf',
  VIDEO = 'mpg,avi,mov,mkv,mp4',
  FLOOR_PLAN = 'jpg,png,jpeg,gif,pdf',
}
